export default __webpack_public_path__ + "bb14f13e154513330e16c005a1eb14c4.svg";